
<h1 mat-dialog-title class="text-center blueHeader dialogHeader text-white">Upload Files</h1>
<mat-dialog-content class="mb-4">
  <div class="text-center">
    <a [class.d-none]="fileUploaded && !multipleFiles && fileUploaded.length == 1"
      (click)="(!multipleFiles && fileUploaded && fileUploaded.length == 1)?null:uploadFile()" class="upload-icon-link"
      href="javascript:void(0);">
      <em class="icon-upload-new"
        [ngClass]="{'disabled': !multipleFiles && fileUploaded && fileUploaded.length == 1}"></em>
      <span>Upload Attachment</span>

    </a>
    <input type="file" id="uploadBtn" (change)="selectFile($event)" accept="{{fileTypeAccepted}}" multiple
      *ngIf="multipleFiles">
    <input type="file" id="uploadBtn" (change)="selectFile($event)" accept="{{fileTypeAccepted}}"
      *ngIf="!multipleFiles">
  </div>

  <div *ngIf="isFileUploaded" style=" margin-top: 8px; ">
    <div class="attachment-info" *ngFor="let file of fileUploaded; let i = index">
      <div class="file-name col-md-12">
        <span id="filename">{{file.fileName}}</span>
        <span class="file-size">({{file.fileSize | number :'1.2-2'}} MB)</span>
        <span class="text-right col-md-5">
          <a href="javascript:void(0);" (click)="deleteFile(file)">
            <span> </span>
            <span>Delete Attachment</span>
          </a>
        </span>
      </div>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-md-12">
    <button mat-button class="mat-raised-button mr-4 btn blankTurquoise btnWidth" (click)="dialogRef.close(false)">Cancel</button>
    <button mat-button class="mat-raised-button btn turquoiseBtn btnWidth" (click)="onUploadFiles(fileUploaded)"
      [disabled]="isDisable">Upload</button>
  </div>
</mat-dialog-actions>
